module.exports = __webpack_public_path__ + "img/integrations.6503f571.svg";